import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Globals } from 'src/shared/globals';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root' // Makes the service a singleton available throughout the app
})

export class PropertiesService {
  constructor(private httpService: HttpClient, private global: Globals) {
  }

  GetService(endPoint: string): Observable<any> {
    const url = `${this.global.apiUrl}Property/${endPoint}`;
    return this.httpService.get(url);
  }

  PostService(endPoint: string, body: any): Observable<any> {
    const url = `${this.global.apiUrl}Property/${endPoint}`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.httpService.post(url, body, httpOptions);
  }

  SearchPropertyService(body: any): Observable<any> {
    const url = `${this.global.apiUrl}Property/SearchProperty`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.httpService.post(url, body, httpOptions);
  }


  public getLocationsByCityId(cityId: any): Observable<any> {
    const url = `${this.global.apiUrl}Property/`;
    return this.httpService.get(url + 'GetLocations?cityId=' + cityId);
  }

  public getCityByCityId(body: any): Observable<any> {
    const url = `${this.global.apiUrl}Property/GetDropDownData`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.httpService.post(url, body, httpOptions);
  }
}
